import { Tenant } from 'types/tenant'
import { UserModel } from '../types'
import { Staff } from 'types/staff'
import { LocationItem } from 'types/location'
import { ServiceItem } from 'types/service'
import { ClientMembershipStatus } from 'types/client'

export type AddressFormValues = {
    street1?: string
    street2?: string
    city?: string
    state?: string
    country?: string
    zip?: string
    timezone: string
}

export type GeneralFormValues = {
    email: string
    notes: string
    phone: string
    first_name: string
    last_name: string
    date_of_birth: string
    language: string
}
type UserRecord = {
    id?: string
    email: string
    first_name: string
    last_name: string
    date_of_birth?: string
    phone?: string
    notes?: string
    preferred_language_id?: string
    createdAt?: string
}

export enum MembershipStatus {
    CURRENT = 'CURRENT',
    LAPSED = 'LAPSED',
    NONE = 'NONE',
}

export type ClientItem = {
    id?: string
    cognito_id?: string
    pwaSubscriberId?: string
    user: UserRecord
    membership_status?: MembershipStatus
    is_archived?: boolean
}

export type ClientApi = {
    tenant?: Tenant,
    user: UserModel,
    notes: string,
    cognitoId: string
}

export type Appointment = { //TODO: really should clean this up
    id: string
    date: string
    time: string
    start_time: string
    end_time: string
    duration: string
    title: string
    staff_object?: Staff
    staff: string
    location_object?: LocationItem
    location: string
    status: string
    amount: string
    imageUrl: string
    schedulingRestriction?: {
        canCancel: boolean
        cancelMinBeforeStartTime: number
        canResched: boolean
        reschedMinBeforeStartTime: number
    }
    is_cancelled?: boolean,
    staff_photo?: string
    attendees?: string[]
    group_class_id?: string
    availability_id?: string
    setting_id?: string
    appointment_id?: string
    service_object?: ServiceItem
    location_space_id?: string
    location_space_name?: string
    notes?: string
    signed_in_at?: string
    fully_paid?: boolean
    order?: any,
    group_class_name?: string
}

export type Order = {
    id: string
    date: string
    time: string
    total: string
    payment_method: string
    status: string
    coupon: string
    item: string
}

export type EventLog = {
    id: string
    type: string
    date: string
    time: string
    transaction: string
    icon: TransactionIcon
}

export type TransactionIcon = {
    feather_icon: string
    color: string
}

export const EVENT_ICONS: Record<string, TransactionIcon> = {
    APPOINTMENT_CANCELLED: {
        feather_icon: 'feather-calendar',
        color: 'bg-red-100 text-red-500'
    },
    APPOINTMENT_CREATED: {
        feather_icon: 'feather-calendar',
        color: 'bg-green-100/60 text-green-900'
    },
    MEMBERSHIP_CANCELLED: {
        feather_icon: 'feather-shopping-bag',
        color: 'bg-red-100 text-red-500'
    },
    MEMBERSHIP_RENEWAL_FAILED: {
        feather_icon: 'feather-shopping-bag',
        color: 'bg-red-100 text-red-500'
    },
    MEMBERSHIP_RENEWED: {
        feather_icon: 'feather-shopping-bag',
        color: 'bg-green-100/60 text-green-900'
    },
    ORDER_CREATED: {
        feather_icon: 'feather-calendar',
        color: 'bg-green-100/60 text-green-900'
    },
    BOOKING: {
        feather_icon: 'feather-calendar',
        color: 'bg-green-100/60 text-green-900'
    },
    PRODUCT: {
        feather_icon: 'feather-shopping-card',
        color: 'bg-green-100/60 text-green-900'
    },
    MEMBERSHIP: {
        feather_icon: 'feather-shopping-bag',
        color: 'bg-green-100/60 text-green-900'
    },
    PAYMENT: {
        feather_icon: 'feather-credit-card',
        color: 'bg-green-100/60 text-green-900'
    },
    SERVICE: {
        feather_icon: 'feather-briefcase',
        color: 'bg-green-100/60 text-green-900'
    },
    NOTIFICATION: {
        feather_icon: 'feather-bell',
        color: 'bg-green-100/60 text-green-900'
    },
    OTHER: {
        feather_icon: 'feather-file',
        color: 'bg-green-100/60 text-green-900'
    }
}
